import { ReactNode } from "react";
import { OuterLabelWrapper, StyledLabel } from "./OuterLabel.styled";
import { Tooltip } from "@mui/material";
import InfoIcon from "@assets/icons_new/iInCircle.svg?react";
interface OuterLabelProps {
  label?: string | false | ReactNode;
  children: ReactNode;
  className?: string;
  tooltip?: string;
  iconColor?: string;
}

export const OuterLabel = ({
  label,
  children,
  className,
  tooltip,
  iconColor = "#727272",
}: OuterLabelProps) => {
  return (
    <OuterLabelWrapper className={className}>
      {typeof label === "string" && (
        <div className="flex items-center gap-[4px]">
          <StyledLabel>{label}</StyledLabel>
          {tooltip && (
            <Tooltip title={tooltip} arrow>
              <div>
                <InfoIcon fontSize={14} color={iconColor} />
              </div>
            </Tooltip>
          )}
        </div>
      )}
      {typeof label === "object" && label}
      {children}
    </OuterLabelWrapper>
  );
};
